import { LocalizationHelper } from "../../helpers"

import { Enums } from "../common/enums"

import { IOpChangeState, IReferenceType } from "../util/interfaces"
import { OpDescr } from "./op-descr"

export class OpConfigurationProfileType implements IOpChangeState, IReferenceType {

    //#region Properties

    public idConfigurationProfileType: number
    public name: string
    public idDescr: number

    public opState: Enums.OpChangeState

    //#endregion


    //#region Navigation properties

    public descr: OpDescr

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#endregion


    //#region IReferenceType implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdConfigurationProfileType
    }
    public getReferenceKey(): number {
        return this.idConfigurationProfileType
    }
    public getReferenceValue(): any {
        return this
    }

    //#endregion


    //#region IOpObject implementation

    public get idObject(): number {
        return this.idConfigurationProfileType
    }

    public set idObject(value: number) {
        this.idConfigurationProfileType = value
    }

    public dynamicValues: { Key: string, Value: any }[] = []


    public toString(): string {
        if (this.descr != null) {
            return this.descr.toString()
        }

        return this.name
    }

    //#endregion


    //#region IJsonSerializer Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idConfigurationProfileType = opObj.ID_CONFIGURATION_PROFILE_TYPE
            this.idDescr = opObj.ID_DESCR
            this.name = opObj.NAME
            this.opState = opObj.OpState
            this.dynamicValues = opObj.dynamicValues
            this.descr = (opObj._Descr != null) ? new OpDescr(opObj._Descr) : null
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_CONFIGURATION_PROFILE_TYPE: this.idConfigurationProfileType,
            ID_DESCR: this.idDescr,
            NAME: this.name,
            OpState: this.opState,
            dynamicValues: this.dynamicValues,
            _Descr: (this.descr != null) ? this.descr.toJSON(compressed) : null,
        }
    }

    //#endregion

}